import React from 'react';
import cn from '@/utils/cn';
import I18n from '@/modules/i18n';
import Icon, { type ValidIcon } from '@/components/ui/Icon';
import { TCITooltip } from '@/components/ui/Tooltip';

type IconTooltipProps = {
  className?: string;
  tooltipContent: React.ReactNode;
  icon?: ValidIcon;
  label?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  size?: number | string;
};

const IconTooltip = ({
  className,
  tooltipContent,
  icon = 'InfoAlternate',
  label = I18n.t('more_info'),
  side = 'top',
  size = 14,
}: IconTooltipProps) => (
  <TCITooltip side={side}>
    <TCITooltip.Trigger
      aria-label={label}
      className={cn('tw-inline-flex tw-border-0 tw-bg-transparent tw-p-0', className)}
      type="button"
    >
      <Icon icon={icon} size={size} />
    </TCITooltip.Trigger>
    <TCITooltip.Content>{tooltipContent}</TCITooltip.Content>
  </TCITooltip>
);

export default IconTooltip;
